import styled from 'styled-components/macro';
import Colors from '../../../internal-components/Colors';
import GoodPagesIds from './GoodPagesIds';

export const Sizes = {
  MOBILE_NAV_BAR_HEIGHT: 60,
  NAV_BAR_HEIGHT: 80,
  FOOTER_HEIGHT: 70
};

export const Section = styled.section`
  height: 100vh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
`;

export const StandardContainer = styled.div`
  padding: 2em;
  background: ${Colors.BACKGROUND_GREY};
  flex: 1 1 auto;

  ${({ pageId }) => {
    if (GoodPagesIds.includes(pageId)) {
      return 'display: flex; flex-direction: column;';
    }
  }}

  ${({ pageId }) => {
    if (pageId === 'groupcreation') {
      return `
        padding: 0;
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        /* NavPage has no flex wrapper around StandardContainer + Footer; fill viewport gap above Footer */
        min-height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}px - ${Sizes.FOOTER_HEIGHT}px);
        overflow: hidden;
      `;
    }
  }}

  ${({ pageId, allowOverflow }) => {
    // Remove bottom padding for dashboard pages to allow footer alignment
    if (pageId === 'new_reports_dashboard_builder' || pageId === 'new_reports_dashboard') {
      if (allowOverflow) {
        // Allow content to extend beyond viewport for scrolling
        return `
          padding-bottom: 0;
          max-height: none;
          overflow: visible;
        `;
      } else {
        // Limit height to viewport to prevent scrollbar
        return `
          padding-bottom: 0;
          max-height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}px);
          overflow: hidden;
        `;
      }
    }
    // Report builder: no vertical scrollbar when viewport is at least 750px tall
    if (pageId === 'new_reports_report_builder') {
      return `
        padding: 0;
        @media (min-height: 750px) {
          height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}px);
          min-height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}px);
          max-height: calc(100vh - ${Sizes.NAV_BAR_HEIGHT}px);
          overflow: hidden;
        }
      `;
    }
  }}

  @media (max-width: 800px) {
    padding: 24px 16px;
    ${({ pageId }) => {
      if (pageId === 'groupcreation') {
        return 'padding: 0;';
      }
      if (pageId === 'new_reports_dashboard_builder' || pageId === 'new_reports_dashboard') {
        return 'padding-bottom: 0;';
      }
      if (pageId === 'new_reports_report_builder') {
        return 'padding: 0;';
      }
    }}
  }

  @media (max-width: 500px) {
    padding: 0;
  }

  @media print {
    padding: 0;
  }

  //   background: -webkit-linear-gradient(
  //     to right,
  //     #d7dde8,
  //     ${Colors.BACKGROUND_GREY}
  //   ); /* Chrome 10-25, Safari 5.1-6 */
  //   background: linear-gradient(
  //     to right,
  //     #d7dde8,
  //     ${Colors.BACKGROUND_GREY}
  //   ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
`;

export const CenteredContainer = styled.div`
  display flex;
  position: fixed;
  left: 0;
  right: 0;
  top:  0;
  bottom: 0;
  margin: auto;
  width: 45vw;
  height: 40vh;
  border-top: 1px solid ${Colors.OT_GREY};
  border-bottom: 1px solid ${Colors.OT_GREY};
`;

export const SimpleFlexContainer = styled.div`
  display: flex;
  flex-direction: ${({ $row }) => ($row ? 'row' : 'column')};
  ${({ $containerCSS }) => $containerCSS}
`;
